"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _usageTrackerContainer = require("usage-tracker-container");

var _primaryTracker;

var _default = {
  track: function track() {
    var eventKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!_primaryTracker) {
      _primaryTracker = (0, _usageTrackerContainer.getPrimaryTracker)();
    }

    return _primaryTracker.track(eventKey, eventProperties);
  }
};
exports.default = _default;
module.exports = exports.default;